/* global BRAND */

import React from 'react'
import { ThemeProvider } from 'styled-components'
import FontsProvider from 'loankeeper-common/components/FontsProvider'

import LazyLoadingProvider from 'shared/LazyLoadingProvider'
import Router from './Router'
import GlobalStyle from './global-styles'
import { SetFavicon } from './features/shared/Helpers'

/* eslint-disable import/no-dynamic-require */
const theme = require(`../brands/${BRAND}/theme.json`)
/* eslint-enable import/no-dynamic-require */
const BrandStyle = require(`../brands/${BRAND}/style.js`).default

if (process.env.FAVICON !== '') {
  /* eslint-enable import/no-dynamic-require */
  const icon = require(`${process.env.FAVICON}`).default
  SetFavicon(icon)
}

const App = () => (
  <>
    <ThemeProvider theme={theme}>
      <FontsProvider>
        <LazyLoadingProvider>
          <Router />
        </LazyLoadingProvider>
      </FontsProvider>
    </ThemeProvider>
    <GlobalStyle />
    <BrandStyle />
  </>
)

if (module.hot) {
  module.hot.accept()
}

export default App
